import { plainToInstance } from "class-transformer";
import ChargeTypeResponse from "entities/chargeTypeResponse";

const SESSION_STORAGE_CHARGE_TYPES_KEY = "charge_types";

export default class ChargeTypesStorageRepository {
  addChargeTypes(chargeTypes: ChargeTypeResponse[]) {
    if (!chargeTypes.length) {
      return;
    }

    const chargeTypesString = sessionStorage.getItem(SESSION_STORAGE_CHARGE_TYPES_KEY);
    if (chargeTypesString) {
      this.removeChargeTypes();
    }
    sessionStorage.setItem(SESSION_STORAGE_CHARGE_TYPES_KEY, JSON.stringify(chargeTypes));
  }

  getChargeTypes() {
    let chargeTypes: ChargeTypeResponse[];
    const chargeTypesString = sessionStorage.getItem(SESSION_STORAGE_CHARGE_TYPES_KEY);
    if (chargeTypesString) {
      chargeTypes = JSON.parse(chargeTypesString) as ChargeTypeResponse[];
      return plainToInstance(ChargeTypeResponse, chargeTypes);
    }
  }

  removeChargeTypes() {
    this.clearChargeTypes();
  }

  storeChargeTypes(chargeTypes: ChargeTypeResponse[]) {
    sessionStorage.setItem(SESSION_STORAGE_CHARGE_TYPES_KEY, JSON.stringify(chargeTypes));
  }

  async clearChargeTypes() {
    sessionStorage.removeItem(SESSION_STORAGE_CHARGE_TYPES_KEY);
  }
}
